import { EventType } from 'constants/enums'
import { CarComparisonStore } from '../store'
import { MAX_VEHICLES } from '../car-comparison/constants'
import { ATTR_NAME } from 'constants/attr-name'
import { TrimSelectorBase } from './trim-selector-base'
import { CLASS_NAME } from 'constants/class-names'

const { trimSelector: className } = CLASS_NAME
/**
 * Trim Selector modal component
 */
export abstract class TrimSelectorCheckbox extends TrimSelectorBase {
    protected preSelected: number[] = []

    protected get templateName(): string {
        return 'trim-selector-checkbox'
    }

    protected get myPicksLength(): number {
        return 0
    }

    public constructor(id: string) {
        super(id)
    }

    /**
     * Handle selector between checkbox and radio
     */
    public handleSelections(): void {
        this.handleCheckboxes()
    }

    /**
     * Add to MyPicks
     */
    public addToMyPicks(): void {
        this.checkedItems = []
        this.closeModal()
    }

    /**
     * Handle checkbox behaviour
     */
    protected handleCheckboxes(): void {
        this.preSelected = []
        // Event listener for checkboxes
        this.checkboxes.forEach((checkbox) => {
            const vehicleID =
                checkbox.getAttribute(
                    ATTR_NAME.driving.trimSelector.vehicleId
                ) || ''

            if (checkbox.checked) {
                this.preSelected.push(parseInt(vehicleID))
                this.onCheckboxChecked(checkbox)
            }

            checkbox.addEventListener(EventType.CHANGE, () => {
                if (checkbox.checked) {
                    this.onCheckboxChecked(checkbox)
                } else {
                    this.onCheckboxUnchecked(checkbox)
                }
            })
        })
    }

    /**
     * Callback to checkbox on
     *
     * @param {HTMLInputElement} checkbox ✅
     */
    protected onCheckboxChecked(checkbox: HTMLInputElement): void {
        checkbox.checked = true
        checkbox.focus()

        if (this.myPicksLength + this.checkedItems.length >= MAX_VEHICLES) {
            // Over the limit
            this.closeModal()
            CarComparisonStore.getInstance()
                .getNoMorePickModal()
                .openModal()
            checkbox.checked = false
            return
        }

        const vehicleId =
            checkbox.getAttribute(ATTR_NAME.driving.trimSelector.vehicleId) ||
            ''
        this.checkedItems.push(parseInt(vehicleId))

        this.setVehicleIcons()
    }

    /**
     * Callback to checkbox off
     *
     * @param {HTMLInputElement} checkbox ✅
     */
    protected onCheckboxUnchecked(checkbox: HTMLInputElement): void {
        checkbox.checked = false
        checkbox.focus()
        const vehicleId =
            checkbox.getAttribute(ATTR_NAME.driving.trimSelector.vehicleId) ||
            ''
        this.checkedItems = this.checkedItems.filter(
            (id) => id !== parseInt(vehicleId)
        )
        this.setVehicleIcons()
    }

    /**
     * Assign CSS class to vehicle icons
     */
    public setVehicleIcons(): void {
        const checkboxLength = this.checkedItems.length
        const myPicksClasses = Array(this.myPicksLength).fill(
            className.vehicleMyPick
        )
        const checkboxClasses = Array(checkboxLength).fill(
            className.vehicleChecked
        )
        const classes = myPicksClasses.concat(checkboxClasses)

        this.vehicleIcons.forEach((icon, index) => {
            icon.classList.remove(
                className.vehicleMyPick,
                className.vehicleChecked
            )

            if (classes.length > index) {
                icon.classList.add(classes[index])
            }
        })

        this.setTrimSelectorButton()
    }

    protected setTrimSelectorButton(): void {
        this.compareButtonText.innerText = `Add ${this.checkedItems.length} to compare`
        this.compareButton.disabled = false
        if (this.checkedItems.length === 0) {
            this.compareButton.disabled = true
            this.compareButtonText.innerText = 'Nothing to compare'
        }
    }
}
